import { z } from 'zod'
import { erc20TransferSchema } from './erc20'
import { erc721TransferSchema } from './erc721'
import { erc1155TransferSchema } from './erc1155'
import { internalTransactionSchema } from './internalTransaction'
import { logSchema } from './log'
import {
  addressPrimitiveSchema,
  bigintTextSchema,
  lowerHexSchema,
  txHashSchema,
} from './primitive'

export const transactionDetailSchema = z.object({
  blockNumber: z.number().int().nonnegative(),
  chainId: z.number().int().positive(),
  contractAddress: addressPrimitiveSchema.optional(),
  effectiveGasPrice: bigintTextSchema,
  erc20Transfers: z.array(erc20TransferSchema),
  erc721Transfers: z.array(erc721TransferSchema),
  erc1155Transfers: z.array(erc1155TransferSchema),
  from: addressPrimitiveSchema,
  gasUsed: bigintTextSchema,
  hash: txHashSchema,
  input: lowerHexSchema,
  internalTransactions: z.array(internalTransactionSchema),
  logs: z.array(logSchema),
  status: z.union([z.literal('success'), z.literal('reverted')]),
  timestamp: z.number().int().nonnegative(),
  to: addressPrimitiveSchema.optional(),
  value: bigintTextSchema,
})

export type TransactionDetail = z.infer<typeof transactionDetailSchema>
